module.exports = __webpack_public_path__ + "static/media/OverheadSquatfemale-cropped.18ed5249.svg";